// src/utils/dashboardCache.js

export const SHARED_FILTER_COLUMNS = [
  'BI_PROVEEDOR', 'BI_MARCA', 'BI_LINEA', 'CLI_SEG_DES',
  'CLI_PRIN', 'CLI_VEN_DES', 'CLI_CANAL', 'CLI_REG_VERD',
  'V_ANULADA', 'CLI_INACTIVO', 'BI_CLASIF2', 'BI_DESC1', 'CLI_CANAL_REAL',
  'CLI_TERRITORIO','BI_SEGMENTO', 'CLI_NOMBRE'
];

export const FACT_FILTER_COLUMNS = [
  'FACT_PROVEEDOR', 'FACT_MARCA', 'FACT_LINEA', 'FACT_PORTAFOLIO',
  'FACT_CLIENTE_PRINCIPAL', 'FACT_VENDEDOR_REGISTRO', 'FACT_CANAL', 'FACT_REGION', 
  'FACT_STATUS_ANULADA', 'FACT_PRODUCTO', 'FACT_CLIENTE_NOMBRE', 'FACT_ART_ID'
];

let memoryCache = {};

const DEFAULT_KEY = 'dimassi_fact_filters_v2';

export const getCachedOptions = (key = DEFAULT_KEY) => {
  if (memoryCache[key]) return memoryCache[key];
  
  try {
    const stored = localStorage.getItem(key);
    if (stored) {
      memoryCache[key] = JSON.parse(stored);
      return memoryCache[key];
    }
  } catch (e) {
    console.warn('Cache read failed:', e);
  }
  return null;
};

export const setCachedOptions = (opts, key = DEFAULT_KEY) => {
  memoryCache[key] = opts;
  try {
    localStorage.setItem(key, JSON.stringify(opts));
  } catch (e) {
    console.warn('Cache write failed:', e);
  }
};

export const clearCache = (key = DEFAULT_KEY) => {
  delete memoryCache[key];
  try {
    localStorage.removeItem(key);
    localStorage.removeItem('salesFilters');
    localStorage.removeItem('dimassi_fact_filters_v2');
  } catch (e) {
    console.warn('Cache clear failed:', e);
  }
};
